import { createContext } from "react";

export const CarritoContext = createContext()